import React from 'react';
import { FileText } from 'lucide-react';
import { Translations } from '../../i18n/translations';

interface ArticleParsingSettingsProps {
  articleParsingEnabled: boolean;
  onArticleParsingChange: (enabled: boolean) => void;
  t: Translations;
}

export const ArticleParsingSettings: React.FC<ArticleParsingSettingsProps> = ({
  articleParsingEnabled,
  onArticleParsingChange,
  t,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-3 sm:p-4 mb-4">
      <h3 className="font-bold mb-2 flex items-center gap-2 text-gray-900 dark:text-white">
        <FileText className="w-4 h-4" aria-hidden="true" />
        {t.articleParsing}
      </h3>
      <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-3">
        {t.articleParsingDesc}
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => onArticleParsingChange(true)}
          className={`px-4 py-2 text-sm font-semibold border-2 transition-colors ${
            articleParsingEnabled
              ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
              : 'bg-white text-black border-gray-300 hover:border-gray-400 dark:bg-gray-700 text-gray-900 dark:text-white dark:border-gray-600 dark:hover:border-gray-500'
          }`}
          aria-pressed={articleParsingEnabled}
        >
          {t.enabled}
        </button>
        <button
          onClick={() => onArticleParsingChange(false)}
          className={`px-4 py-2 text-sm font-semibold border-2 transition-colors ${
            !articleParsingEnabled
              ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
              : 'bg-white text-black border-gray-300 hover:border-gray-400 dark:bg-gray-700 text-gray-900 dark:text-white dark:border-gray-600 dark:hover:border-gray-500'
          }`}
          aria-pressed={!articleParsingEnabled}
        >
          {t.disabled}
        </button>
      </div>
    </div>
  );
};
